import { Component, Input } from '@angular/core';
import { LocalOfficeContact } from '../../../../../core/store/admin/local-office/local-office.interface';
import { FormGroup } from '@angular/forms';

@Component({
  selector: 'app-edit-contact',
  templateUrl: './edit-contact.component.html',
  styleUrls: ['./edit-contact.component.scss']
})
export class EditContactComponent {

  @Input() label: string;
  @Input() contact: LocalOfficeContact;
  @Input() formGroup: FormGroup;
}
